import { DynamicLegalPage } from "./DynamicLegalPage";
import { useTranslation } from "react-i18next";

export function CookiesPage() {
  const { t } = useTranslation();
  const sections = (() => {
    const v = t("cookies.page.sections", { returnObjects: true });
    return Array.isArray(v) ? (v as Array<{ title: string; body: string }>) : [];
  })();
  return (
    <DynamicLegalPage
      slug="cookies"
      fallback={{
        eyebrow: t("cookies.page.eyebrow"),
        title: t("cookies.page.title"),
        intro: t("cookies.page.intro"),
        sections,
      }}
    />
  );
}
